import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import useAlternativeOffer from '@/v2/components/pages/PackageViewV2/hooks/useAlternativeOffer/useAlternativeOffer';
import CampaignOfferMessage from './components/CampaignOfferMessage';
import NoOfferWarning from './components/NoOfferWarning';
import { WarningProps } from './components/NoOfferWarning/NoOfferWarning';

export type UnavailableWarningProps = WarningProps;

const UnavailableWarning = (props: UnavailableWarningProps) => {
  const { selectedPackageOption, selectedRoomOption, isLoading, isPreSearch } =
    useRoomOptionsData() || {};
  const { alternativeOffer } = useAlternativeOffer() || {};
  const { offer, roomType } = alternativeOffer || {};
  const isAltOfferAvailable = !!(offer && roomType);

  if (selectedRoomOption || isPreSearch || isLoading) {
    return null;
  }

  return isAltOfferAvailable ? (
    <Flex flexDirection="column" gap="12px">
      <NoOfferWarning.OtherOffer
        {...props}
        dealName={selectedPackageOption?.title ?? 'deal'}
      />
      <CampaignOfferMessage
        isAltOfferAvailable={isAltOfferAvailable}
        {...props}
      />
    </Flex>
  ) : (
    <NoOfferWarning.NoOffer {...props} />
  );
};

export default UnavailableWarning;
